module.exports = __webpack_public_path__ + "./img/logoParadigmaPie.a6eb174e7cf7c74d902b1099536df649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoParadigmaPie.png
// module id = ./src/assets/img/logoParadigmaPie.png
// module chunks = 14